<main class="container-fluid container-fluid-limited main-page px-1 px-md-4 pt-3">
    <div class="position-relative taskbook my-4">
        <div class="welcome">
            <div class="d-lg-flex justify-content-between align-items-center">
                <div>
                    <h1 class="fs-5">{{ 'taskbook.welcome' | translate }}</h1>
                    <p class="text-secondary welcome_desc">{{ 'taskbook.welcome_2' | translate }}</p>
                </div>
                <div class="border-start pt-3 ps-3 ms-3">
                    <saved-filter [pageTitle]="pageTitle" 
                                    [manageDate]="false"
                                    [managerInDialog]="true"
                                    [dateInterval]="dateInterval" 
                                    [selectedNamedFilter]="selectedFilter" 
                                    (filterChange)="onFilterChange($event)" 
                                    [onlyWhereIAMAdmin]="true"></saved-filter>
                </div>
            </div>
                                
            <div>
                <div class="pt-4">
                    <mat-progress-bar mode="determinate" [value]="taskProgressionValue"></mat-progress-bar>
                </div>
                <div class="d-flex justify-content-between pt-2 text-secondary">
                    @if(taskProgressionValue === 100){
                        <div class="">
                            @if(numberOfTasks>0){
                                {{numberOfTasks}} {{ 'taskbook.feedback_reviewed' | translate }}
                            }
                            <p class="fw-bold">{{ 'taskbook.review_feedback.empty' | translate:{filter:selectedFilter.name} }}</p>
                        </div>
                        <div class="text-secondary">100% {{ 'taskbook.done' | translate }}</div>
                    }@else {
                        <div class="" data-cy="currentTask">{{ 'taskbook.current_feedback' | translate }}{{numberOfCurrentTask}}</div>
                        <div class="text-secondary">{{numberOfRemainingTasks}} {{ 'taskbook.remaining_feedback' | translate }}</div>
                    }
                </div>
            </div>
        </div>

        <div class="task-wrapper py-5">
            @if(showSpinner){
                <div class="text-center text-secondary pb-3">
                    <i class="far fa-spinner fa-spin fa-2x"></i>
                </div>
            }
            @else{
                @if(!currentTask.error){
                    <div class="row task-row w-100 mx-0" data-cy="currentTaskContent">
                        <div class="col-md-7">
                                <task [task]="currentTask"
                                            [teams]="teams"
                                            [userId]="userId"
                                            [userInfos]="userInfos"
                                            [threadInCreation]="threadInCreation"
                                            (onReportTaskContent)="openModerationDialog(currentTask)"
                                            (onAction)="onThreadCreation($event)"></task>
                        </div>
                        <div class="col-md-5">
                            <taskbook-triage-actions [task]="currentTask"
                                                     [managers]="managers"
                                                     (onAction)="onAction($event)"></taskbook-triage-actions>
                        </div>
                    </div>           
                }@else{
                    <div class="row pb-3">
                        <div class="col-md-6">
                            <div class="d-flex justify-content-center align-items-center">
                                <img src="/assets/images/add_comment/talking-people.svg" width="300" class="pt-md-5">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="text-secondary kudos-intro">
                                <h3 class="pt-3 pb-2">{{'triage.review_feedback.success_title' | translate}}</h3>
                                <p class="pb-2 fs-6">{{'triage.review_feedback.success_desc1' | translate}}</p>
                                <ul class="fs-6">
                                    @if(hasMoreItemsInOtherTeams){
                                    <li>
                                        <a class="fw-bold" (click)="loadAllTeamsFilter()">{{'triage.review_feedback.success_desc2' | translate}}</a> {{'triage.review_feedback.success_desc2.1' | translate}}
                                    </li>
                                    }
                                    <li>
                                        <a class="fw-bold" routerLink="/backlog">{{'triage.review_feedback.success_desc1.1' | translate}}</a>  {{'triage.review_feedback.success_desc1.2' | translate}}
                                    </li>
                                    <li>
                                        <a class="fw-bold" (click)="poll()">{{'triage.review_feedback.success_desc3' | translate}}</a> {{'triage.review_feedback.success_desc3.1' | translate}}
                                    </li>
                                    <li>
                                        <a class="fw-bold" (click)="kudos()">{{'triage.review_feedback.success_desc4' | translate}}</a> {{'triage.review_feedback.success_desc4.1' | translate}}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                }
            }
        </div>
    </div>
</main>